export const BILLING_PAGE_SIZE = 20;
export const BILLING_DETAIL_PAGE_SIZE = 30;
